module.exports = __webpack_public_path__ + "static/media/mn.460f99ee.svg";